/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
// Component
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 *
 * @param {Object} param0
 * @returns
 */
const ZigzagCards = ({ sectionContent, region, lang }) => {
  // const isEvenIndex = index % 2 == 0;
  // const flexDirection = isEvenIndex ? 'row-reverse' : 'row';
  // const textAlign = isEvenIndex ? 'left' : 'right';
  // const float = isEvenIndex ? 'right' : 'left';
  return (
    <Box width="100%" height="auto" maxW={'1300px'} mx="auto">
      <Box px={{ md: '150px', base: '0' }} mt="56px" mb="100px">
        <Flex flexDir={{ md: 'row', base: 'column' }}>
        </Flex>
        {sectionContent[1].cards.map((item, index) => {
          return (
            <Box key={nanoid}>
              <Flex
                flexDir={{
                  md: index % 2 == 0 ? 'row-reverse' : 'row',
                  base: 'column',
                }}
              >
                <Flex
                  alignItems={'center'}
                  flex={1}
                  p="15px"
                >
                  <LazyLoadImageComponent src={item?.thumbnails[0]?.url} alt={item.thumbnails[0].alt} title={item.thumbnails[0].title} />
                </Flex>
                <Flex alignItems={'center'} flex={1} p="15px">
                  <Box
                    className="cardsDes"
                    fontFamily='"FedraSansStd-book", sans-serif'
                    fontSize="20px"
                    color="#060606"
                    marginTop="20px"
                  >
                    {index === 0 && (
                      <LazyLoadImageComponent
                        width={'240px'}
                        alt={sectionContent[0].image.alt}
                        title={sectionContent[0].image.title}
                        src={sectionContent[0].image.url}
                      />
                    )}

                    <Box
                      fontFamily='"FedraSansStd-A-medium", sans-serif'
                      fontSize={{ md: '40px', base: '27px' }}
                      color="#000000"
                    >
                      {item.title}
                    </Box>
                    <StructuredTextParser
                      str={render(item.description)}
                      region={region}
                      lang={lang}
                      fontFamily="'FedraSansStd-book', sans-serif"
                      fontSize="20px !important"
                      className="itemDescriptionApp"
                      color="#060606"
                      mt={{ base: '16px', md: '20px' }}
                      textAlign="left"
                    />
                  </Box>
                </Flex>
              </Flex>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ZigzagCards;
